module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    attrs: {
      "icon": "el-icon-refresh"
    },
    on: {
      "click": function($event) {
        return _vm.clickEvent()
      }
    }
  }, [_vm._v("重置")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-3707c179"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/myButton/ResetButton.vue
// module id = 1900
// module chunks = 1